import { useQuery } from '@tanstack/react-query';
import { adminFetch } from '@/lib/apiClient';

/**
 * QA-468 — 주문 엑셀 상품 추가입력 라벨(order #75). 최근 N일 주문에 쓰인 라벨, 많이 쓰인 순(최대 200).
 *   GET /api/admin/v1/orders/export/collection-labels?days=90 → [{ key: "productCollectionInput:국적 nationality", label, count }]
 * BE 반영 전(404 등)이면 빈 목록 — 라벨 그룹만 비고 나머지 항목 고르기는 그대로.
 */
export interface ExportCollectionLabel {
  key: string;
  label: string;
  count: number;
}

export const exportCollectionLabelsKey = (days: number) => ['admin', 'orders', 'export', 'collection-labels', days] as const;

export const useExportCollectionLabelsQuery = (enabled: boolean, days = 90) =>
  useQuery<ExportCollectionLabel[]>({
    queryKey: exportCollectionLabelsKey(days),
    enabled,
    staleTime: 5 * 60_000,
    queryFn: async () => {
      const res = await adminFetch(`/api/admin/v1/orders/export/collection-labels?days=${days}`);
      if (!res.ok) return [];
      const env = (await res.json().catch(() => null)) as { data?: unknown } | null;
      const rows = Array.isArray(env?.data) ? (env.data as Array<Partial<ExportCollectionLabel>>) : [];
      return rows
        .filter((r): r is ExportCollectionLabel => typeof r.key === 'string' && typeof r.label === 'string')
        .map((r) => ({ key: r.key, label: r.label, count: typeof r.count === 'number' ? r.count : 0 }));
    },
  });
